<div class="not-found-page">
  <div class="not-found-container">
    <div class="head">{{ "PAGE.ERROR.HEAD" | translate }}</div>
    <div class="text">{{ "LABELS.SOMETHING_DONT_WORK_TITLE" | translate }}</div>
    <button class="btn btn-primary" (click)="home()">{{ "HOME" | translate }}</button>
  </div>
</div>
